module.exports = __webpack_public_path__ + "static/img/taxcellent_tp.8eb531a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/taxcellent_tp.png
// module id = Beb/
// module chunks = 34